<div class="summary-container">
    <div class="header-wrapper">
        <div class="alertCount">
            <div class="showCount border-light-right">
                <p #deduporigin class=" title bold-text content-l">Showing {{alertvarservice.no_of_alerts}} grouped alerts</p>
            </div>
            <!-- <img src="assets/asset_host/left-arrow.svg" (click)="moveplatformlist(-1)"> -->

            <div #chipMeasure class="chips border-light-right chip-measure">
                <ng-container *ngFor="let chip of alertvarservice.chips">
                    <!-- same chip HTML -->
                    <ng-container *ngFor="let options of chip|keyvalue">
                        <ng-container *ngFor="let head of alertvarservice.alertFilterTitles|keyvalue:originalOrder">
                            <ng-container *ngIf="options.key===head.key">


                                <ng-container *ngIf="options.key==='time' || options.key==='platform' ">

                                    <div #chipElement class="chip chip-item disable-action secondary-text my-2 mr-2 px-4 pt-1 radius-xl chips-default" (click)="removeChip(chip)">
                                        <p class="content-s">{{head.value}}</p>
                                        <p class="content-s bold-text">: {{options.value.disp}}</p>
                                        <!-- <img class="icon-s" src="assets/rule/close-dialog.svg" (click)="removeChip(chip)"> -->
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="options.key!='time' && options.key!='platform' ">
                                    <div #chipElement class="chip chip-item enable-action secondary-text my-2 mr-2 px-4 pt-1 radius-xl border-report" (click)="removeChip(chip)">
                                        <p class="content-s">{{head.value}}</p>
                                        <p class="content-s bold-text">: {{options.value.disp}}</p>
                                        <!-- <img class="icon-s" src="assets/rule/close-dialog.svg" (click)="removeChip(chip)"> -->
                                    </div>
                                </ng-container>


                            </ng-container>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </div>

            <div #chipList #chipOrgin class="chips border-light-right">

                <ng-container *ngIf="alertvarservice.chips.length>0">
                    <!-- <ng-container *ngFor="let chip of alertvarservice.chips| slice:0:11"> -->
                    <ng-container *ngFor="let chip of visibleChips">
                        <ng-container *ngFor="let options of chip|keyvalue">
                            <ng-container *ngFor="let head of alertvarservice.alertFilterTitles|keyvalue:originalOrder">
                                <ng-container *ngIf="options.key===head.key">


                                    <ng-container *ngIf="options.key==='time' || options.key==='platform' ">

                                        <div #chipElement class="chip chip-item disable-action secondary-text my-2 mr-2 px-4 pt-1 radius-xl chips-default" (click)="removeChip(chip)">
                                            <p class="content-s">{{head.value}}</p>
                                            <p class="content-s bold-text">: {{options.value.disp}}</p>
                                            <!-- <img class="icon-s" src="assets/rule/close-dialog.svg" (click)="removeChip(chip)"> -->
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="options.key!='time' && options.key!='platform' ">
                                        <div #chipElement class="chip chip-item enable-action secondary-text my-2 mr-2 px-4 pt-1 radius-xl border-report" (click)="removeChip(chip)">
                                            <p class="content-s">{{head.value}}</p>
                                            <p class="content-s bold-text">: {{options.value.disp}}</p>
                                            <!-- <img class="icon-s" src="assets/rule/close-dialog.svg" (click)="removeChip(chip)"> -->
                                        </div>
                                    </ng-container>


                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                    <!-- <ng-container *ngIf="chips.length>13">
                    <div class="chip secondary-text my-2 mr-2 px-4 pt-1 radius-xl border-report" (click)="moreChips()">
                      <p class="content-s bild-text">+{{chips.length -13}} more</p>
                    </div>
                </ng-container> -->
                    <div class="option">
                        <div class="create selectable-text enable-action" (click)="openSourceMenu_click(chipmenu,chipOrgin)">
                            <!-- <ng-container *ngIf="alertvarservice.chips.length>11"> -->
                            <ng-container *ngIf="morechipslist.length">
                                <div class="chip enable-action secondary-text my-2 mr-2 px-4 pt-1 radius-xl border-report" (click)="moreChips()">
                                    <!-- <p class="content-s bold-text">+{{alertvarservice.chips.length - 11}} more</p> -->
                                    <p class="content-s bold-text">+{{morechipslist.length}} more</p>
                                </div>
                            </ng-container>
                        </div>
                        <ng-template #chipmenu>
                            <div class="source-container p-3 content-m primary-text white-bg dropdown-shadow radius-m">
                                <!-- <ng-container *ngFor="let option of morechips"> -->
                                <ng-container *ngFor="let option of morechipslist">
                                    <ng-container *ngFor="let overlaychip of option|keyvalue">
                                        <div class="chip enable-action secondary-text my-2 mr-2 px-4 pt-1 radius-xl border-report" (click)="removeMoreChip(option)">
                                            <p class=" key content-s ">{{overlaychip.key}}</p>
                                            <p class="content-s bold-text ">: {{overlaychip.value.disp}}</p>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </ng-template>
                    </div>
                </ng-container>
            </div>

            <!-- <img src="assets/asset_host/right-arrow.svg" (click)="moveplatformlist(1)"> -->
            <div class="buttons">
                <h5 class="clear selectable-text bold-text enable-action" (click)="clearFilter()">{{alertvarservice.titles.summaryTableTitles.clear}}</h5>
                <button class="submit" (click)="applyFilter_click()">{{alertvarservice.titles.summaryTableTitles.filter}}</button>
                <!-- <button class="submit" (click)="opencreate()">Filter</button> -->
            </div>
        </div>
        <div class="tables">
            <ng-container *ngIf="spinner_alert_filter_state">
                <div class="filter-spinner">
                    <mat-spinner class="filter-spinner" diameter=20></mat-spinner>
                </div>
            </ng-container>
            <ng-container *ngIf="!spinner_alert_filter_state">
                <table>
                    <tr>
                        <th *ngFor="let head of alertvarservice.alertFilterTitles|keyvalue:originalOrder">
                            {{head.value}}
                        </th>
                        <th *ngFor="let head of alertvarservice.alertInfoTitles|keyvalue:originalOrder">
                            {{head.value}}
                        </th>
                    </tr>
                    <tbody>
                        <tr>
                            <td *ngFor="let filter of alertFilter.filters|keyvalue:originalOrder;let i=index">
                                <div class="border-light-right " [ngClass]="filter.key != 'observable' ? 'list' :'observable-list'">
                                    <ng-container *ngIf="filter.key != 'tags'">
                                        <ng-container *ngIf="filter.value.values.length>0">
                                            <ng-container *ngIf="filter.key != 'observable'">
                                                <ng-container *ngFor="let list of filter.value.values">
                                                    <div class="tableData enable-action" (click)="optionClick(filter.key,list)">
                                                        <!-- <ng-container *ngFor="let chip of alertvarservice.chips">
                              <ng-container *ngFor="let data of chip | keyvalue ">
                                <ng-container *ngIf="list.value===data.value.value"> -->
                                                        <p class=" hoverChange content-m tooltip-enable " [ngClass]="checkChips(filter.key,list)? 'selectable-text':'primary-text'" [tooltip]="list.disp">{{list.disp}}
                                                        </p>
                                                        <p class="content-m selectable-text">
                                                            {{list.count | numberComma}}</p>
                                                        <!-- </ng-container>
                              </ng-container>
                            </ng-container> -->
                                                    </div>
                                                </ng-container>
                                            </ng-container>
                                            <ng-container *ngIf="filter.key == 'observable'">
                                                <cdk-virtual-scroll-viewport itemSize="10" minBufferPx="200" maxBufferPx="400" class="example-viewport">
                                                    <div class="tableData enable-action" *cdkVirtualFor="let list of filter.value.values" (click)="optionClick(filter.key,list)">
                                                        <!-- <ng-container *ngFor="let chip of alertvarservice.chips">
                              <ng-container *ngFor="let data of chip | keyvalue ">
                                <ng-container *ngIf="list.value===data.value.value"> -->
                                                        <p class=" hoverChange content-m tooltip-enable " [tooltip]="list.disp" [ngClass]="checkChips(filter.key,list)? 'selectable-text':'primary-text'">{{list.disp}}
                                                        </p>
                                                        <p class="content-m selectable-text">{{list.count | numberComma}}</p>
                                                        <!-- </ng-container>
                              </ng-container>
                            </ng-container> -->
                                                    </div>
                                                    <!-- <span class="content-m selectable-text enable-action more" (click)="moreItem()"
                          *ngIf="filter.value.values.length > limitCount">more</span> -->
                                                </cdk-virtual-scroll-viewport>
                                            </ng-container>
                                        </ng-container>
                                        <ng-container *ngIf="filter.value.values.length==0">
                                            <div class="tableData none ">
                                                <p class=" content-m primary-text">{{alertvarservice.titles.summaryTableTitles.none}}</p>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                    <ng-container *ngIf="filter.key === 'tags'">
                                        <ng-container *ngIf="filter.value.values.length>0">
                                            <ng-container *ngFor="let tagGroup of filter.value.values">
                                                <ng-container *ngFor="let group of tagGroup | keyvalue: originalOrder">
                                                    <p class="bold-text content-l primary-text">{{ group.key | titlecase }}</p>
                                                    <ng-container *ngFor="let tag of group.value">
                                                        <div class="tableData enable-action" (click)="optionClick(filter.key, tag)">
                                                            <p class="hoverChange tooltip-enable  content-m primary-text pl-5" [tooltip]="tag.disp">{{ tag.disp }}</p>
                                                            <p class="content-m selectable-text">{{tag.count | numberComma}}</p>
                                                        </div>
                                                    </ng-container>
                                                </ng-container>
                                            </ng-container>
                                        </ng-container>
                                        <ng-container *ngIf="filter.value.values.length==0">
                                            <div class="tableData none ">
                                                <p class=" content-m primary-text">{{alertvarservice.titles.summaryTableTitles.none}}</p>
                                            </div>
                                        </ng-container>
                                    </ng-container>

                                </div>
                            </td>
                            <td *ngFor="let filter of alertFilter.informations|keyvalue:originalOrder;let i=index">
                                <div class="list" [ngClass]="filterSize-1 !=i ? '' :'border-light-right'">
                                    <ng-container *ngIf="filter.key != 'tags'">
                                        <ng-container *ngIf="filter.value.values.length>0">
                                            <ng-container *ngFor="let list of filter.value.values">
                                                <div class="tableData not-allowed">
                                                    <p class=" hoverChange1 content-m primary-text">{{list.disp}}</p>
                                                    <p class="content-m selectable-text">{{list.count | numberComma}}</p>
                                                </div>
                                            </ng-container>
                                        </ng-container>
                                        <ng-container *ngIf="filter.value.values.length==0">
                                            <div class="tableData none ">
                                                <p class=" content-m primary-text">{{alertvarservice.titles.summaryTableTitles.none}}</p>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                    <ng-container *ngIf="filter.key === 'tags'">
                                        <ng-container *ngIf="filter.value.values.length>0">
                                            <ng-container *ngFor="let tagGroup of filter.value.values">
                                                <ng-container *ngFor="let group of tagGroup | keyvalue: originalOrder">
                                                    <p class="bold-text content-l primary-text">{{ group.key | titlecase }}</p>
                                                    <ng-container *ngFor="let tag of group.value">
                                                        <div class="tableData not-allowed">
                                                            <p class="hoverChange1 content-m primary-text pl-5">{{ tag.disp }}</p>
                                                            <p class="content-m selectable-text">{{tag.count | numberComma}}</p>
                                                        </div>
                                                    </ng-container>
                                                </ng-container>
                                            </ng-container>
                                        </ng-container>
                                        <ng-container *ngIf="filter.value.values.length==0">
                                            <div class="tableData none ">
                                                <p class=" content-m primary-text">{{alertvarservice.titles.summaryTableTitles.none}}</p>
                                            </div>
                                        </ng-container>
                                    </ng-container>

                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ng-container>
        </div>
        <!-- <div class="header-bottom" [formGroup]="alertvarservice.alertFilters"
      [ngStyle]="{'display':'grid','align-items': 'center'}">
      <div class="header-bottom-col-1">
        <ng-container formGroupName="external">
          <div class="header-bottom-col-1-1" #platformOrigin (click)="openAssetsDropdown_click(platformOrigin)">
            <label class="form-label-on"> {{alertMetaData.filterlabels[3]}} </label>
            <div class="platform-icon" [ngClass]="inProgress ? 'disable-platform' : 'enable-platform'">
              <div class="platform-count">
                <p>{{alertvarservice.platformMap[platform.value]}}</p>
                <span *ngIf="impactedHost.value.uniqueHostsLength">({{impactedHost.value.uniqueHostsLength}})</span>
              </div>
             
              <span class="material-icons">arrow_drop_down</span>
            </div>
          </div>
          <div class="header-bottom-col-1-2" #severityOrigin [ngClass]="inProgress ? 'disable-click' : 'enable-click'">
            <app-overlay-select formControlName="severity"
              [data]="alertMetaData.filterOptions.all | manageAll: alertvarservice.commondata.severityOptions"
              [origin]="severityOrigin" [style]="{'font-size':'9px'}" [label]="alertMetaData.filterlabels[0]">
            </app-overlay-select>
          </div>
          <div class="header-bottom-col-1-3" #timeZoneOrigin [ngClass]="inProgress ? 'disable-click' : 'enable-click'">
            <app-overlay-select formControlName="timezone" [data]="alertMetaData.filterOptions.timeZone"
              [origin]="timeZoneOrigin" [style]="{'font-size':'9px'}" [label]="alertMetaData.filterlabels[1]">
            </app-overlay-select>
          </div>
          <div class="header-bottom-col-1-4" #timeRangeOrigin [ngClass]="inProgress ? 'disable-click' : 'enable-click'">
            <app-overlay-select formControlName="timerange" [data]="alertMetaData.filterOptions.timeRanges"
              [origin]="timeRangeOrigin" [style]="{'font-size':'9px'}" [label]="alertMetaData.filterlabels[2]">
            </app-overlay-select>
          </div>
        </ng-container>
        <ng-container formGroupName="internal">
          <div class="header-bottom-col-1-5" #alertCountOrigin
            [ngClass]="inProgress ? 'disable-click' : 'enable-click'">
            <app-overlay-select formControlName="alertcount" [data]="alertMetaData.filterOptions.count"
              [origin]="alertCountOrigin" [style]="{'font-size':'9px'}" [label]="alertMetaData.filterlabels[5]">
            </app-overlay-select>
          </div>

          <div class="header-bottom-col-1-6" #alertpercentageOrigin
            [ngClass]="inProgress ? 'disable-click' : 'enable-click'">
            <app-overlay-select formControlName="alertpercentage" [data]="alertMetaData.filterOptions.percentage"
              [origin]="alertpercentageOrigin" [style]="{'font-size':'9px'}" [label]="alertMetaData.filterlabels[6]">
            </app-overlay-select>
          </div>

          <div class="header-bottom-col-1-7">
            <label class="tag-label">{{alertMetaData.advancedFilter.header}}</label>
            <div class="tags-container" #overlayOrigin>
              <div class='tag-autocomplete' [ngClass]="inProgress ? 'disable-tag' : 'enable-tag'">
                <input class="input is-medium" [placeholder]="alertMetaData.filterlabels[7]"
                  [tagAutocomplete]="[tagdirective,overlayOrigin]"
                  [inputdisable]="alertvarservice.tagsSearchcontrol.disabled"
                  [formControl]="alertvarservice.tagsSearchcontrol">
              </div>
              <div class="tags-val" [ngClass]="inProgress ? 'disable-tag-val' : 'enable-tag-val'">
                <p>{{selectedTags}} selected</p>
                <img [ngClass]="inProgress ? 'disable-click' : 'enable-click'" src="assets/alerts/close.svg"
                  (click)="cleartagvalue()">
              </div>
              <tag-autocomplete #tagdirective="tagautocomplete">
                <ng-template tagAutocompleteContent>
                  <ng-container [formGroup]="tags">
                    <ng-container *ngFor="let group of alertvarservice.distag|keyvalue;let i=index">
                      <tag-option-group *ngIf="group.value.length > 0"
                        [label]="alertvarservice.commondata.tags.mapping[group.key]" [formGroupName]="group.key">
                        <tag-option *ngFor="let option of group.value" [value]="option.disp"
                          class="autocomplete-option">
                          <label> <input type="checkbox" [formControlName]="option.val"> <span>{{
                              option.disp}}</span></label>
                        </tag-option>
                      </tag-option-group>
                    </ng-container>
                    <tag-option class="no-result" *ngIf="!optionsGroup.length">
                      <span>{{alertMetaData.noDatamsg[1]}}</span>
                    </tag-option>
                  </ng-container>
                </ng-template>
              </tag-autocomplete>
            </div>
          </div>
        </ng-container>
      </div>

      <div tooltip="Reset" (click)="resetFilterResult()"
        [ngClass]="inProgress?'disable-button tooltip-enable':'enable-button tooltip-enable'" class="resetbutton">
        <img src="assets/alerts/refresh.svg">
      </div>

      <div class="header-bottom-col-2">
        <button (click)="applyFilter_click()" [ngClass]="inProgress?'disable-action':'enable-action'">{{inProgress ?
          'Cancel':'FILTER'}}</button>
      </div>

    </div> -->

    </div>
    <div class="body-wrapper radius-m white-bg p-3" [ngClass]="alertFilterState ? 'body-wrapper-filter':'body-wrapper-without-filter'">
        <div class="body-top">
            <div class="body-top-col-1">
                <button class="border-none white-bg" (click)="paginationTable_click(-1)" [ngClass]="page.value | disableAction:alertvarservice.alertpagelength:-1:inProgress">
          <img class="icon-s" src="assets/alerts/left-arrow.svg">
        </button>
                <p class="primary-text content-m">{{page.value}} of {{alertvarservice.alertpagelength}}</p>
                <button class="border-none white-bg" (click)="paginationTable_click(1)" [ngClass]="page.value | disableAction:alertvarservice.alertpagelength:1:inProgress">
          <img class="icon-s" src="assets/alerts/right-arrow.svg">
        </button>
            </div>

            <div class="body-top-col-2">
                <div class="body-top-col-2-1" [formGroup]="alertvarservice.alertFilters" #paginationOrigin>
                    <ng-container *ngFor="let pagedata of alertvarservice.commondata.pagination | keyvalue">
                        <p class="primary-text content-m">{{pagedata.key}}</p>
                        <app-overlay-select formControlName="itemPerPage" [data]="pagedata.value" fontsize="input-m" [style]="{'background':'transparent'}">
                        </app-overlay-select>
                    </ng-container>
                </div>
            </div>

            <div class="body-top-col-3">
                <button class="border-none white-bg" tooltip="Refresh" (click)="refreshAlertTables()" [ngClass]="inProgress?'disable-button tooltip-enable':'enable-button tooltip-enable'">
          <img class="icon-s" src="assets/alerts/refresh-data.svg">
        </button>
                <button class="border-none white-bg">
          <img class="icon-s" tooltip="Download" (click)="downloadAlertpdf_click()" src="assets/alerts/download.svg"
            [ngClass]="inProgress?'disable-button tooltip-enable':'enable-button tooltip-enable'">
        </button>
                <button class="border-none white-bg" (click)="screenMode(!fullscreenState)" tabindex="0">
          <img class="icon-s" [tooltip]="!fullscreenState ? 'expand':'collapse'"
            [ngClass]="inProgress?'disable-button tooltip-enable':'enable-button tooltip-enable'"
            [src]="!fullscreenState ? 'assets/alerts/resize-line.svg':'assets/alerts/shrink-line.svg'"
            (click)="closeAlertFilter_click()">
        </button>
            </div>
        </div>

        <div class="body-bottom">
            <!-- {{filter_changes_state}} -->
            <ng-container *ngIf="!spinner_alert_list_state">
                <ng-container *ngIf="alertvarservice.alertRows.length">
                    <div class="body-bottom-left">
                        <table>
                            <thead>
                                <tr>
                                    <!-- <th [ngClass]="'alert-severity'">{{alertMetaData?.alertTableHeaders[0]?.disp}}</th> -->
                                    <ng-container *ngFor="let item of alertMetaData?.alertTableHeaders">
                                        <th [ngClass]="item.value == 'alertTitle'?'alert-name':''">{{item.disp}}</th>
                                    </ng-container>
                                    <!-- <th>{{alertMetaData?.alertTableHeaders[7]?.disp}}</th>
                  <th [ngClass]="'alert-name'">{{alertMetaData?.alertTableHeaders[1]?.disp}}</th>
                  <th>{{alertMetaData?.alertTableHeaders[2]?.disp}}</th>
                  <th>{{alertMetaData?.alertTableHeaders[3]?.disp}}</th>
                  <th>{{alertMetaData?.alertTableHeaders[3]?.disp}}</th>
                  <th>{{alertMetaData?.alertTableHeaders[4]?.disp}}</th>
                  <th>{{alertMetaData?.alertTableHeaders[5]?.disp}}</th>
                  <th [ngClass]="'alert-severity'">SEVERITY</th> -->
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngIf="alertvarservice.alertSummaryData">
                                    <ng-container *ngFor="let alert of alertvarservice.alertRows | slice:(page.value-1)*itemPerPage.value :(page.value)*itemPerPage.value">
                                        <!-- <tr (click)="openFactsheet_click(alert)"> -->
                                        <tr>
                                            <ng-container *ngFor="let item of alertMetaData?.alertTableHeaders">
                                                <ng-container *ngIf="item.val != 'severity' && item.val != 'platform' && item.val != 'alertPercentage'">
                                                    <td (click)="openFactsheet_click(alert)" [ngClass]="item.val == 'alertTitle'?'alert-name':''" [tooltip]="alert[item.val]">
                                                        {{item.val != 'lastAlertTime'?alert[item.val]:alert[item.val] * 1| changetimezone : 'DD-MM-YYYY HH:mm'}}</td>
                                                </ng-container>
                                                <ng-container *ngIf="item.val == 'alertPercentage'">
                                                    <td (click)="openFactsheet_click(alert)">{{alert[item.val]}}%</td>
                                                </ng-container>
                                                <ng-container *ngIf="item.val == 'platform'">
                                                    <td (click)="openFactsheet_click(alert)">{{alertvarservice.platformMap[alert[item.val]]}}</td>
                                                </ng-container>
                                                <ng-container *ngIf="item.val == 'severity'">
                                                    <td (click)="openFactsheet_click(alert)" [ngClass]="'alert-severity'">
                                                        <!-- <div class="severity-code" [ngClass]="alert.severity"></div>
                        <span>{{alert.severity}}</span> -->
                                                        <div class="severity-code">
                                                            <span class="severity-color-code" [ngClass]="alert[item.val]">
                              </span>
                                                            <span class="severity-value-code">
                                {{alert[item.val] |titlecase}}
                              </span>
                                                        </div>
                                                    </td>

                                                </ng-container>
                                            </ng-container>
                                            <!-- <td (click)="openFactsheet_click(alert)">{{alert.alertId}}</td>
                      <td [ngClass]="'alert-name'" [tooltip]="alert.alertTitle" (click)="openFactsheet_click(alert)">
                        {{alert.alertTitle }}</td>
                      <td (click)="openFactsheet_click(alert)">{{alertvarservice.platformMap[alert.platform]}}</td>
                      <td (click)="openFactsheet_click(alert)">{{alert.alertCount}}</td>
                      <td (click)="openFactsheet_click(alert)">{{alert.closeCount}}</td>
                      <td (click)="openFactsheet_click(alert)">{{alert.alertPercentage}}%</td>
                      <td (click)="openFactsheet_click(alert)">{{alert.lastAlertTime * 1| changetimezone : 'DD-MM-YYYY
                        HH:mm'}}</td> -->
                                            <ng-template #host>
                                                <div class="host-container">
                                                    <div class="host-wrapper">
                                                        <p *ngFor="let hosts of alert.hosts">{{hosts}}</p>
                                                    </div>
                                                </div>
                                            </ng-template>
                                            <!-- <td #orgin [ngClass]="'alert-severity'" (click)="openFactsheet_click(alert)">
                        <div class="severity-code">
                          <span class="severity-color-code" [ngClass]="alert?.severity">
                          </span>
                          <span class="severity-value-code">
                            {{alert?.severity |titlecase}}
                          </span>
                        </div>
                      </td> -->
                                            <td>
                                                <div class="p-2 border-light radius-m primary-bg" (click)="openDedup(deduporigin,alert.alertId,alert.status)"> De-dup</div>
                                            </td>
                                            <td>
                                                <div *ngIf="alert.status == 1" class="options">
                                                    <div #orgin class="create selectable-text enable-action" (click)="openSourceMenu_click(menu,orgin,$event)" hasPermission [hasPermissionModule]="sharedService.moduleNames.alert" [hasPermissionMode]="'Add'">
                                                        <img class="icon-s" src="../../../../assets/widgets/more-options.svg">
                                                    </div>
                                                    <ng-template #menu>
                                                        <div class="source-container-2 content-m primary-text white-bg dropdown-shadow">
                                                            <ng-container *ngFor="let option of alertvarservice.ruleTypes">
                                                                <p (click)="clickcreate(option,alert)" [ngClass]="option.value==='auto_investigate' || option.value==='auto_closure' || option.value==='direct_to_signal'? 'enable-action hover-bg opacity-high':'disable-action opacity-low permission-denied'" class="m-0">{{option.disp}}</p>
                                                            </ng-container>
                                                        </div>
                                                    </ng-template>
                                                </div>
                                            </td>
                                        </tr>
                                    </ng-container>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>
                </ng-container>
                <ng-container *ngIf="!alertvarservice.alertRows.length">
                    <div class="no-data-container">
                        <img src="/assets/empty-data.svg">
                        <div class="no-data"> {{ handleprovidealertdataerror.status ? handleprovidealertdataerror.errmsg : alertMetaData.noDatamsg[0] }} </div>
                    </div>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="spinner_alert_list_state">
                <div class="body-bottom-spinner">
                    <mat-spinner class="spinner" diameter=20></mat-spinner>
                </div>
            </ng-container>
        </div>
    </div>
</div>

<ng-template #deduppop let-dialogRef="dialogRef">
    <mat-dialog-content class="p-0 m-0">
        <!-- <p class="content-l primary-text p-3 pb-2 pt-2">Do you want to replace the existing query?</p> -->
        <!-- <p class="content-l primary-text p-3 pb-2 pt-2">Do you want delete this template?</p> -->
        <div class="dialog-container">
            <app-de-dup></app-de-dup>
        </div>

    </mat-dialog-content>
    <!-- <mat-dialog-actions align="end">
    </mat-dialog-actions> -->
</ng-template>